import { Observable } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import refreshToken from './refresh-token';

export const errorLink = onError(({ graphQLErrors, networkError, protocolErrors, operation, forward }) => {
  if (protocolErrors) {
    protocolErrors.forEach(({ message, extensions }) => {
      console.info(`[Protocol error]: Message: ${message}, Extensions: ${JSON.stringify(extensions)}`);
    });
  }

  if (networkError) {
    console.info(`[Network error]: ${networkError}`);
  }

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      switch (err?.extensions?.code) {
        case 'UNAUTHENTICATED':
          return new Observable((observer) => {
            refreshToken()
              .then((newAccessToken) => {
                operation.setContext({
                  headers: {
                    ...operation.getContext().headers,
                    authorization: `Bearer ${newAccessToken}`,
                  },
                });

                const subscriber = {
                  next: observer.next.bind(observer),
                  error: observer.error.bind(observer),
                  complete: observer.complete.bind(observer),
                };

                forward(operation).subscribe(subscriber);
              })
              .catch((error) => {
                observer.error(error);
              });
          });

        case 'USER_NOT_LOGGED_IN':
          setTimeout(() => {
            window.location.href = '/login';
          }, 1000);
          break;
      }
    }
  }
});
